import React from "react";
import {Navigate} from "react-router-dom";
import AuthenticationService from "./AuthenticationService";
import { useLocation } from 'react-router-dom';
export default function PrivateRoute ({children}) {
    const authed = AuthenticationService.isUserLoggedIn();
    const location = useLocation();
    return authed ? children : <Navigate to={`/login?redirectTo=${location.pathname}`}/>
}